import {Typography} from "@mui/joy";

const TOS = () => {
    return (
        <div className={"container"}>
            <Typography level={"h1"}>Terms of Service</Typography>
            <Typography level={"title-md"}>Effective Date: 05/05/2025</Typography>
            <Typography level={"body-md"}>
                These Terms of Service ("Terms") govern your use of Online Interactives (the "App"). By using the App, you agree to comply with these Terms.
            </Typography>
            <Typography level={"h3"}>1. Use of the App</Typography>
            <Typography level={"body-md"}>
                The App is free to use, and no account or subscription is required. You are solely responsible for the content you create (such as quizzes or polls) through the App. The App serves as a mechanism to view this content in an interactive way and does not store or control the content itself.
            </Typography>
            <Typography level={"h3"}>2. Restrictions on Use</Typography>
            <Typography level={"body-md"}>
                You agree not to use the App for any illegal activity, harassment, or misuse of features. You are responsible for ensuring that your content does not violate any laws or infringe on any third-party rights.
            </Typography>
            <Typography level={"h3"}>3. Ownership of Content</Typography>
            <Typography level={"body-md"}>
                You, as the creator, retain ownership of the content you create, including quizzes and polls. The App does not claim any ownership over your content.
            </Typography>
            <Typography level={"h3"}>4. Liability Disclaimer</Typography>
            <Typography level={"body-md"}>
                The App is provided "as is," and we make no representations regarding the accuracy, reliability, or suitability of the content or functionality. We are not responsible for any issues arising from the use of the App.
            </Typography>
            <Typography level={"h3"}>5. Modification and Termination</Typography>
            <Typography level={"body-md"}>
                We reserve the right to modify, suspend, or terminate access to the App or any of its features at any time, for any reason, or if we believe you have violated these Terms.
            </Typography>
            <Typography level={"h3"}>6. Governing Law</Typography>
            <Typography level={"body-md"}>
                These Terms are governed by the laws of [Your Jurisdiction], without regard to its conflict of law principles.
            </Typography>
            <Typography level={"h3"}>7. Changes to Terms</Typography>
            <Typography level={"body-md"}>
                We may update these Terms from time to time. Any changes will be posted on this page with an updated effective date.
            </Typography>
        </div>
    )
}

export default TOS;